import React from "react";
import ReactDOM from "react-dom";
import "./assets/fonts/fonts.css";
import App from "./App";
import AuthStateContext from "./context/AuthContext";

const container = document.getElementById("app");

ReactDOM.render(<App />, container);
